// src/layouts/Login/index.js

import React, { useEffect } from "react"
import { useAuth0 } from "@auth0/auth0-react"

import Loading from 'components/Loading'

const Login = () => {
  const { loginWithRedirect } = useAuth0()

  useEffect(() => loginWithRedirect(), [loginWithRedirect])
  
  return <Loading text="Please wait" />
}

export default Login
